export const DOCUMENT_GROUP_NODE_NAME = "__INTERNAL__ Documents";
export const RULE_GROUP_HOLDER_NODE_NAME = "__INTERNAL__ Rule Groups";
export const ACTION_GROUP_NODE_NAME = "__INTERNAL__ Actions";
export const TRIGGER_GROUP_NODE_NAME = "__INTERNAL__ Triggers";
